export const rhode_island = {
  "44000": "Rhode Island",
  "44001": "Bristol County",
  "44003": "Kent County",
  "44005": "Newport County",
  "44007": "Providence County",
  "44009": "Washington County",
};
